import { _initialState } from './_initialState';

export const productInfoStore = (set, get) => ({
  ..._initialState,
  updateProductInfo: ({
    ...data
  }) => set({
    productInfo: {
      ...data,
      displayName: data?.displayName || 'Storage',
      partnerProductId: data?.partnerProductId || '325168962',
    }
  }, false, { type: 'updateProductInfo' })
});
